<template>
  <div>
    <el-dialog
      v-if="dialogOption.dialogVisible"
      v-el-dialog-drag
      show-close
      width="500px"
      visible
      :title="dialogOption.title"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <el-form
        size="mini"
        ref="form"
        :model="formData"
        :rules="rules"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="业务时间" prop="setDateTime" size="small">
              <el-date-picker
                style="width:100%"
                format="yyyy-MM-dd HH:mm:ss"
                v-model="formData.setDateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="请选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="close()">取消</el-button>
        <el-button type="primary" @click="confirm()">确认提货</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    selectList: {
      type: Array,
      default: () => [],
    },
    selectDispatchNoList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (
        new Date().getTime() < new Date(this.formData.setDateTime).getTime()
      ) {
        callback(new Error('提货时间不能大于当前时间'))
      } else {
        callback()
      }
    }
    return {
      listCode: [],
      formData: {
        setDateTime: '',
      },
      rules: {
        setDateTime: [
          {
            required: true,
            validator: validateDate,
            trigger: ['change', 'blur'],
          },
          { required: true, message: '请选择提货时间', trigger: 'change' },
        ],
      },
      dialogOption: {
        title: '提货确认',
        dialogVisible: false,
      },

      expireDate: '',
      pickerOptions: {
        // selectableRange: (() => {
        //   var data = new Date()
        //   let hour = data.getHours()
        //   let minute = data.getMinutes()
        //   let second = data.getSeconds()
        //   return [`00:00:00 - ${hour}:${minute}:${second}`]
        // })(),

        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  watch: {
    selectList: {
      handler(selectList) {
        this.listCode = selectList
        this.dialogOption.dialogVisible = true
      },
      immediate: true,
    },
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.$confirm(
        '确认要对当前的运输订单，进行【提货】操作吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .carriageWaybillDetailIsPickupApi({
            listCode: this.listCode,
            dispatchOrderNoList: this.selectDispatchNoList,
            setDateTime: this.formData.setDateTime,
          })
          .then((res) => {
            this.close()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('comitOk')
          })
      })
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
  },
}
</script>
